import { ApiUrls } from '@/common/domain/Endpoints.domain';
import instance from '@/common/service/api/Axios';
import { TConfig } from '@/common/service/api/Config/Config.domain';

export const fetchConfig = async () => {
    return instance.get<TConfig>(ApiUrls.config.root).then(({ data }) => {
        return data;
    });
};
